export enum EN_ROLE_LEVEL {
  LOOK = 10,
  COMPILE = 100,
  MANAGE = 1000,
  OWNER = 10000,
  All_USER = 0,
  FORBID = -1,
}
